export class CartQuantityUpdateRule {
	/**
	 * Recibe MenuItem original y el nuevo monto, aplicando la conversión de precisión (BigInt)
	 */
	public static updateQuantity<T extends { cantidad?: bigint }>(target: T, newQuantity?: number | string): T {
		return {
			...target,
			cantidad: this.isValid(newQuantity) ? BigInt(newQuantity ?? 1n) : 1n,
		};
	}

	public static isValid(newQuantity?: number | string): boolean {
		if (!newQuantity) return false;
		if (Number(newQuantity) <= 0) return false;

		return true;
	}
}
